import { RouteConfig } from 'vue-router';
const User = () => import('./views/user.vue');
const Information = () => import('./views/information.vue');
const routers: RouteConfig[] = [
    {
        path: 'user',
        component: User,
    },
    {
        path: 'information',
        component: Information,
    },
];
export default routers;
